import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutSection.css';

const AboutSection = () => {
  const { t } = useTranslation();
  return (
    <section id="about" className="about-section">
      <div className="about-section__container">
        <div className="about-section__header">
          <span className="about-section__label">{t('about.label')}</span>
          <h2 className="about-section__title">{t('about.title')}</h2>
          <p className="about-section__subtitle">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="about-section__content">
          <div className="about-section__story">
            <div className="about-section__story-text">
              <h3>{t('about.story.title')}</h3>
              <p>
                {t('about.story.text1')}
              </p>
              <p>
                {t('about.story.text2')}
              </p>
            </div>
            <div className="about-section__story-visual">
              <div className="about-section__icon-box">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L3 7v10l9 5 9-5V7l-9-5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                  <path d="M12 22V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M12 12L3 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M12 12l9-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
          </div>

          <div className="about-section__values">
            <div className="about-section__value">
              <div className="about-section__value-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>{t('about.values.reliability.title')}</h4>
              <p>{t('about.values.reliability.description')}</p>
            </div>
            <div className="about-section__value">
              <div className="about-section__value-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>{t('about.values.empathy.title')}</h4>
              <p>{t('about.values.empathy.description')}</p>
            </div>
            <div className="about-section__value">
              <div className="about-section__value-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>{t('about.values.innovation.title')}</h4>
              <p>{t('about.values.innovation.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(AboutSection);






